<template>
  <div id="app">
    <router-view ></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  created() {
    // console.log('在页面刷新时将vuex里的信息保存到localStorage里')
    // 在页面刷新时将vuex里的信息保存到localStorage里
    // window.addEventListener("beforeunload", () => {
    //   localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
    // });
    // // 在页面加载时读取localStorage里的状态信息
    // localStorage.getItem("messageStore") &&
    //   this.$store.replaceState(
    //     Object.assign(
    //       this.$store.state,
    //       JSON.parse(localStorage.getItem("messageStore"))
    //     )
    //   );
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<!-- 这个style 不加 scoped 就是全局样式，专门放滚动条/全局公共样式，优先级最高 -->
<style lang="scss">
/* ============ 全局统一滚动条样式 - 全部区域生效 包括ElementUI组件 ============ */
/* 1. 全局滚动条基础样式 (页面/自定义div/所有滚动容器) */
::-webkit-scrollbar {
  width: 6px;  /* 竖滚动条宽度 */
  height: 6px; /* 横滚动条高度 */
}
/* 滚动条轨道（背景） */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 3px;
}
/* 滚动条滑块（拖动的实心块，核心） */
::-webkit-scrollbar-thumb {
  background-color: #dcdcdc;
  border-radius: 3px;
  cursor: pointer;
}
/* 鼠标悬浮滑块高亮 */
::-webkit-scrollbar-thumb:hover {
  background-color: #bfbfbf;
}
/* 鼠标点击滑块加深 */
::-webkit-scrollbar-thumb:active {
  background-color: #999999;
}

/* ============ 兼容ElementUI所有组件的滚动条【必加，否则el-table/el-dialog滚动条不生效】 ============ */
.el-table__body-wrapper::-webkit-scrollbar,
.el-table__header-wrapper::-webkit-scrollbar,
.el-dialog__body::-webkit-scrollbar,
.el-card__body::-webkit-scrollbar,
.el-scrollbar__wrap::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.el-table__body-wrapper::-webkit-scrollbar-track,
.el-table__header-wrapper::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table__header-wrapper::-webkit-scrollbar-thumb {
  background: #dcdcdc;
  border-radius: 3px;
}
</style>
